import { gql } from '@apollo/client';

export const WANDZ_PASSIVE_DATA_QUERY = gql`
  query WANDZ_PASSIVE_DATA_QUERY {
    userState { isLoggedIn }
    config {
      rewardExpiringSoon: bool(name: "rewardExpiringSoon")
    }
  }
`;
